import { iframeResizer } from 'iframe-resizer';

const getElement = elOrId => {
  if (!elOrId) throw Error('Element or an id if required');
  if (typeof elOrId === 'string') {
    const id = elOrId.replace('#', '');
    const div = document.getElementById(id);
    if (!div) throw Error("Couldn't find an element with id:" + id);
    return div;
  }
  return elOrId;
};

const createEmbed = (id, options) => {
  var div = getElement(id);
  var iframe = document.createElement('iframe');
  iframe.scrolling = 'no';
  iframe.style.width = '100%';
  iframe.style.border = 'none';
  iframe.style.opacity = '0';
  div.appendChild(iframe);
  let hasResizedOnce = false;
  const url = `${process.env.URL ? process.env.URL : window.location.origin}`;
  iframe.src = url;
  iframe.onload = () => {
    iframeResizer(
      {
        log: false,
        heightCalculationMethod: 'documentElementOffset',
        resizedCallback() {
          // Avoid render the first time with the wrong height.
          if (!hasResizedOnce) {
            iframe.style.opacity = '1';
            hasResizedOnce = true;
          }
        },
      },
      iframe
    );
  };
};

window._smuCreateEmbed = createEmbed;



// WEBPACK FOOTER //
// ./src/create-embed.js